import { Directive, ElementRef, inject, input, OnDestroy, OnInit, output, Renderer2 } from '@angular/core';
import { NumberErrorType } from '@compeople-shared/design-system';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[artCustomNumberError]',
  standalone: true,
})
export class AutoErrorDirective implements OnInit, OnDestroy {
  artCustomNumberErrorMessage = input.required<string>();
  artCustomNumberErrorType = input.required<NumberErrorType>();
  controlError = output<Record<string, boolean>>();

  private el = inject(ElementRef<HTMLDxNumberInputElement>);
  private renderer = inject(Renderer2);
  private ngControl = inject(NgControl, { optional: true });
  private cleanupFn?: () => void;

  ngOnInit(): void {
    this.cleanupFn = this.renderer.listen(
      this.el.nativeElement,
      'errorFound',
      (event: CustomEvent<{ type: NumberErrorType }>) => {
        const hasError = event.detail.type === this.artCustomNumberErrorType();
        this.el.nativeElement.errormessage = hasError ? this.artCustomNumberErrorMessage() : '';
        if (this.ngControl) {
          const record: Record<string, boolean> = {
            [this.ngControl.name as string]: hasError,
          };
          this.controlError.emit(record);
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.cleanupFn?.();
  }
}
